import { ChangeEvent, useRef, useState } from 'react';

import { Controller, useFormContext } from 'react-hook-form';
import { FiImage, FiX } from 'react-icons/fi';
import toast from 'react-hot-toast';

import Button from '@components/Button';

import * as S from '../styles';
import { FieldRendererProps } from '../types';

const ImageField = ({ field, disabled }: FieldRendererProps) => {
  const { control } = useFormContext();
  const inputRef = useRef<HTMLInputElement>(null);
  const [preview, setPreview] = useState<string | null>(null);

  const handleClick = () => {
    inputRef.current?.click();
  };

  return (
    <Controller
      name={field.name}
      control={control}
      defaultValue={null}
      render={({ field: formField }) => {
        const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
          const file = e.target.files?.[0];
          if (file) {
            // Check file size if max_size is specified (in KB)
            if (field.max_size && file.size > field.max_size * 1024) {
              toast.error(`Imagem muito grande. Máximo: ${field.max_size}KB`);
              return;
            }

            // Create preview
            const reader = new FileReader();
            reader.onloadend = () => {
              setPreview(reader.result as string);
            };
            reader.readAsDataURL(file);

            formField.onChange(file);
          }
        };

        const handleRemove = () => {
          formField.onChange(null);
          setPreview(null);
          if (inputRef.current) {
            inputRef.current.value = '';
          }
        };

        const acceptTypes = field.accept || 'image/*';

        return (
          <S.FileInputWrapper>
            <input
              ref={inputRef}
              type="file"
              accept={acceptTypes}
              onChange={handleFileChange}
              disabled={disabled}
              style={{ display: 'none' }}
            />

            {preview ? (
              <S.ImagePreview>
                <img src={preview} alt="Preview" />
                <Button
                  type="button"
                  variant="transparent"
                  size="even"
                  icon={<FiX />}
                  onClick={handleRemove}
                  disabled={disabled}
                />
              </S.ImagePreview>
            ) : (
              <S.ImageDropzone onClick={handleClick} $disabled={disabled}>
                <FiImage size={32} />
                <span>
                  {field.placeholder || 'Clique para selecionar uma imagem'}
                </span>
              </S.ImageDropzone>
            )}

            {field.help_text && <S.HelpText>{field.help_text}</S.HelpText>}
          </S.FileInputWrapper>
        );
      }}
    />
  );
};

export default ImageField;
